module.exports = __webpack_public_path__ + "197633d0c1d341589fbfe679543dee1b.otf";